import { render, staticRenderFns } from "./IconButtonFake.vue?vue&type=template&id=1f5b66c5&scoped=true&"
import script from "./IconButtonFake.vue?vue&type=script&lang=js&"
export * from "./IconButtonFake.vue?vue&type=script&lang=js&"
import style0 from "./IconButtonFake.vue?vue&type=style&index=0&id=1f5b66c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5b66c5",
  null
  
)

export default component.exports